// extracted by mini-css-extract-plugin
module.exports = {"login-page":"login-page--wAS3Y","loginPage":"login-page--wAS3Y"};